var id_list = {
  "2024": {
    session: "二",
    year: "2024", 
    sid: "", 
    address: "南京", 
    startTime: "2024.08.23", 
    endTime: "2024.08.24", 
    haslive: false, // 是否进行直播
    formurl: "", // "https://vip.msup.com.cn/index.php/weixin/feedback/form-feedback?formId=2905", // 咨询表单
    formid: "", // 咨询表单 // https://acrm.msup.com.cn/form/detail?form_id=81
    caseid: "", // 案例征集
    caseurl: "", // 案例征集表单
    livevod: 0, // 有直播时是否使用回放模式（会议结束后确定视频后用1，直播前和直播中用0）
    livetype: 0, // 直播类型（0-直播助手无聊天室，1-线上直播有聊天室）
    sueid: { 
      sidlecturer1: '',    // 联席主席
      sidlecturer2: '',    // 出品人
      sidlecturer3: '',    // 选题委员会
      sidcase: '',         // 精选案例
      sidsponsor: '',      // 赞助商
      feedbackPopId: '',   // 赞助商(直播反馈)
      sidsponsorhistory: '', // 历史参会企业 48
      sidsponsorunite : '', // 联合主办方 329
      openingid: '',       // 开幕式
    },
    sponsorimg: "", // 联合主办方
    sponsorcontent: { '高级赞助': [], '礼品赞助': [], '合作推广伙伴': [], }, // '金牌赞助': [], '银牌赞助': [], '铜牌赞助': [],  '图书赞助': [],
  },
  "2023sh": {
    session: "一",
    year: "2023", 
    sid: "3917", 
    address: "南京", // "上海", 
    startTime: "2023.12.22", 
    endTime: "2023.12.23", 
    haslive: false, // 是否进行直播
    formurl: "", // "https://vip.msup.com.cn/index.php/weixin/feedback/form-feedback?formId=2905", // 咨询表单
    formid: "83", // 咨询表单 // https://acrm.msup.com.cn/form/detail?form_id=81
    caseid: "", // 案例征集
    caseurl: "", // 案例征集表单
    livevod: 0, // 有直播时是否使用回放模式（会议结束后确定视频后用1，直播前和直播中用0）
    livetype: 0, // 直播类型（0-直播助手无聊天室，1-线上直播有聊天室）
    sueid: { 
      sidlecturer1: '335',    // 联席主席
      sidlecturer2: '336',    // 出品人
      sidlecturer3: '337',    // 选题委员会
      sidcase: '338',         // 精选案例
      sidsponsor: '339',      // 赞助商
      feedbackPopId: '263',   // 赞助商(直播反馈)
      sidsponsorhistory: '', // 历史参会企业 48
      sidsponsorunite : '', // 联合主办方 329
      openingid: '340',       // 开幕式
    },
    sponsorimg: "", // 联合主办方
    sponsorcontent: { '高级赞助': [], '礼品赞助': [], '合作推广伙伴': [], }, // '金牌赞助': [], '银牌赞助': [], '铜牌赞助': [],  '图书赞助': [],
  },
};

// export const year = "2023sh";
// export const sid = "3917";
export const id_arr = {...id_list};
export const session = (year)=>{return id_list[year].session;};
export const sid = (year)=>{return id_list[year].sid;};
export const address = (year)=>{return id_list[year].address;};
export const startTime = (year)=>{return id_list[year].startTime;};
export const endTime = (year)=>{return id_list[year].endTime;};
export const haslive = (year)=>{return id_list[year].haslive}
export const formid = (year)=>{return id_list[year].formid;};
export const _formurl = (year)=>{return id_list[year].formurl;};
export const caseid = (year)=>{return id_list[year].caseid;};
export const caseurl = (year)=>{return id_list[year].caseurl;};
export const livevod = (year)=>{return id_list[year].livevod};
export const livetype = (year)=>{return id_list[year].livetype};
export const sidsponsorhistory = (year)=>{return id_list[year].sueid.sidsponsorhistory}; // 历史参会企业
export const sidsponsor = (year)=>{return id_list[year].sueid.sidsponsor};   // 赞助商
export const sidlecturer1 = (year)=>{return id_list[year].sueid.sidlecturer1}; // 联席主席
export const sidlecturer2 = (year)=>{return id_list[year].sueid.sidlecturer2}; // 出品人
export const sidlecturer3 = (year)=>{return id_list[year].sueid.sidlecturer3}; // 选题委员会
export const sidcase = (year)=>{return id_list[year].sueid.sidcase};      // 精选案例
export const feedbackPopId = (year)=>{return id_list[year].sueid.feedbackPopId}; // 赞助商
export const sidsponsorunite = (year)=>{return id_list[year].sueid.sidsponsorunite}; // 联合主办方
export const openingid = (year)=>{return id_list[year].sueid.openingid}; // 开幕式
export const sponsorimg = (year)=>{return id_list[year].sponsorimg};      // 联合主办方
export const sponsorcontent = (year)=>{return id_list[year].sponsorcontent};     // (首页)赞助商类型


// url
export const formUrl = "https://acrm.msup.com.cn/form/detail?form_id="; // 表单-峰会咨询
export const caseUrl = "https://vip.msup.com.cn/index.php/weixin/feedback/form-feedback?formId="; // 表单(报名/案例征集)
export const getMeetingTime = "https://www.msup.com.cn/api/api-common/get-simple-scheduling-data?sid=";
export const getAllCourse = 'https://api.msup.com.cn/scheduling/get-all-courses/'
export const getThemeInfo = "https://api.msup.com.cn/group/get-group-project/" // 议题设置
export const getScheduleInfo = "https://api.msup.com.cn/scheduling/get-schedule/" // 会议日程
export const getSpeechInfo = "https://api.msup.com.cn/group/get-group-project/" // 会议日程
export const getSpeechInfoNew = "https://api.msup.com.cn/group/get-group-project-new/" // 会议日程
export const getSpeechInfoFinal = "https://api.msup.com.cn/group/get-group-project-final/" // 会议日程
export const getSpeechTheme = "https://api.msup.com.cn/group/get-group-project/" // 演讲专题
export const getThemeDetail = "https://api.msup.com.cn/group/group-project-info/" // 专题详情
export const getScheduleDetail = "https://api.msup.com.cn/course/view/" // 获取客户详情
export const getTicket = "https://www.msup.com.cn/api/api-common/tickets-info" // 获取门票信息
export const createOrder = "https://www.msup.com.cn/api/api-common/create-order-of-top" // 生成订单
export const getUserInfo = "https://www.msup.com.cn/api/top-api/user-set" // 获取用户个人信息
export const getMyTicket = "https://www.msup.com.cn/api/api-common/get-all-activation-ticket" // 个人拥有的门票
export const getBuyTicket = "https://www.msup.com.cn/api/api-common/get-all-ticket" // 个人购买的门票
export const getUserOrder = "https://www.msup.com.cn/api/top-api/get-order" // 个人的订单
export const openInvoice = "https://www.msup.com.cn/api/top-api/apply-invoice" // 开具发票
export const checkHash = "https://www.msup.com.cn/api/api-common/check-order-diys-by-params" // 判断hash是否有效
export const getSue = "https://api.msup.com.cn/sue/get-all-sue-info/"; // 推荐位、广告位
export const getSueLecturer = "https://api.msup.com.cn/sue/obtain-sue-lecturer/"; // 推荐位-讲师
export const getLecturerList = "https://api.msup.com.cn/lecturer/get-all-lecturer-by-sid/" //  演讲嘉宾
export const getLecturerInfo = "https://api.msup.com.cn/lecturer/view" // 嘉宾信息
// export const getSueInfo = "https://api.msup.com.cn/sue/get-all-sue-info/243" // 赞助商
// export const getSueLecturer1 = "https://api.msup.com.cn/sue/obtain-sue-lecturer/240" // 联席主席
// export const getSueLecturer2 = "https://api.msup.com.cn/sue/obtain-sue-lecturer/241" // 出品人
// export const getSueLecturer3 = "https://api.msup.com.cn/sue/obtain-sue-lecturer/242" // 精选案例
// export const getSueLecturer4 = "https://api.msup.com.cn/sue/obtain-sue-lecturer/244" // 选题委员会
